import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useClientData } from '@/providers/ClientData.provider';
import useFetchAuthorizedIPs from '@/hooks/useApi/useFetchAuthorizedIPs';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

const { Box, Title, SubTitle, Button, Table } = vp;
type FC = FunctionComponent;
const AuthorizedIps: FC = () => {
  const history = useHistory();
  const { response } = useClientData();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const [authorizedIPs, getAuthorizedIPs] = useFetchAuthorizedIPs({});
  useEffect(() => {
    getAuthorizedIPs({
      PortalUser: response.LoginUserName,
    });
  }, []);
  const authorizedIPsList = authorizedIPs?.AuthorizedIPs.split(',').filter((x) => x !== '');
  const tableProps: vp.TableProps = {
    variant: 'record',
    name: 'Authorized-IP-Table',
    hasNoHead: true,
    columns: {
      Record: { header: '' },
    },
    rows:
      authorizedIPsList?.map((ip) => ({
        Record: ip,
      })) || [],
  };
  return (
    <div>
      <Box flx="col" mb="md" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/settings');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : t('pageTitle')}
        </UtilButton>
        <Title title={t('AuthorizedIps.title', { defaultValue: 'Authorize IP Addresses' })} />
      </Box>
      <Box flx="col">
        <SubTitle subTitle={t('AuthorizedIps.howItWorks', { defaultValue: 'How it works' })} />
        <Box mb="sm">
          {t('AuthorizedIps.description', { defaultValue: 'This list of IP addresses identifies specific machines that are authorized to make requests using your account. Use a comma separated list (e.g. "127.0.0.1, 0.0.0.0") to enable multiple machines, or use the wildcard character (*) to allow access from anywhere.' })}
        </Box>
        <Box mb="sm">
          {t('AuthorizedIps.note', { defaultValue: 'Note: Using the wildcard character (*) poses a security risk and should be avoided if possible.' })}
        </Box>
        <SubTitle subTitle={t('AuthorizedIps.currentlyAuthorized', { defaultValue: 'Currently authorized:' })} />
        {authorizedIPsList?.length === 0 && <Box mb="sm">{t('AuthorizedIps.noIpAddresses', { defaultValue: 'You have no authorized IP addresses.' })}</Box>}
        {authorizedIPsList?.length && authorizedIPsList?.length > 0 && (
          <Box mb="sm">
            <Table {...tableProps} />
          </Box>
        )}

        <Box mt="lg" jc="fe">
          <Box>
            <Button
              id="AuthorizedIps-update"
              label={t('AuthorizedIps.updateButton', { defaultValue: 'Update Authorized IPs' })}
              onClick={() => {
                history.push('/settings/authorized-ips/update');
              }}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default AuthorizedIps;
